import { render } from "./GetStarted.vue?vue&type=template&id=27fb4ca2"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"

import "./GetStarted.vue?vue&type=style&index=0&id=27fb4ca2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__